import * as Yup from 'yup';
import { useMemo } from 'react';

export const BlogSchema = (currentBlog: any) => {
  const NewBlogSchema = Yup.object().shape({
    title: Yup.string().min(3).required('Title is required'),
    description: Yup.string().min(3).required('Description is Required'),
    image: Yup.string().required('Image is required'),
    keywords: Yup.array().min(1).required('keywords is required'),
  });
  const defaultValues: any = useMemo(
    () => ({
      title: currentBlog?.title || '',
      title_ar: currentBlog?.title_ar || '',
      description: currentBlog?.description || '',
      description_ar: currentBlog?.description_ar || '',
      keywords: currentBlog?.keywords || [],
      keywords_ar: currentBlog?.keywords_ar || [],
      content: currentBlog?.content || '',
      content_ar: currentBlog?.content_ar || '',
      // isActive: currentBlog?.isActive || false,
      image: currentBlog?.image || '',
      seoDescription: currentBlog?.seoDescription || '',
      seoDescription_ar: currentBlog?.seoDescription_ar || '',
    }),
    [currentBlog]
  );

  return { NewBlogSchema, defaultValues };
};
